



































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { getdatalist } from "@/api/autolearnCount";
import { drawEchart } from "./../../publicjs/echarts";
@Component({
  name: "equipManage",
})
export default class extends Vue {
  [x: string]: any;

  mounted() {
    this.$nextTick(() => {
      this.getlist(this.listQuery);
    });
  }
  updated() {}
  private listQuery: any = {
    name: "",
    page: 1,
    limit: 10,
    begintime: null,
    endtime: null,
    timetype: "",
  };
  private tableData: any = [];
  private multiarry: any = []; //表格复选框id
  private total: number = 0;
  private echartsFirstLoad: any = [];
  private xdata = [];
  private echartsFirstUpdate: any = []; //echarts下拉项选择改变后值
  private dialogXdata: any = []; //对话框x轴数据
  private dialogYdata: any = []; //对话框Y轴数据
  private echartsXnama: any = [];
  private echartsXdata: any = []; //使用率echarts横轴数据
  private echartsYdata: any = []; //使用率echarts横轴数据echarts纵轴数据
  private button = [{ name: "周" }, { name: "月" }, { name: "年" }];
  private isactive = 4;
  private type = "primary";
  private isloading = true;
  private allParams = {
    dataValue: "",
    dialogVisible: false,
    title: "",
    dataType: "week",
    beginType: "请选择开始时间",
    endType: "请选择结束时间",
    endtime: "",
    begintime: "",
    dateText: "yyyy 第 WW 周",
  };
  private starttime = {
    disabledDate: (time: any) => {
      if (this.listQuery.endtime) {
        return time.getTime() > new Date(this.listQuery.endtime).getTime();
      } else {
        return time.getTime() > Date.now();
      }
    },
  };
  private endtime = {
    disabledDate: (time: any) => {
      if (this.listQuery.begintime) {
        return (
          time.getTime() > Date.now() ||
          time.getTime() < new Date(this.listQuery.begintime).getTime()
        );
      } else {
        return time.getTime() > Date.now();
      }
    },
  };
  private async searchData() {
    (this.$refs.tableref as any).clearSelection();
    if (this.listQuery.timetype != "") {
      if (this.listQuery.begintime == null || this.listQuery.endtime == null) {
        this.$message({
          message: "请选择起始和结束时间",
          type: "warning",
        });
      } else {
        this.echartsXnama = [];
        this.echartsXdata = [];
        this.echartsYdata = [];
        await getdatalist(this.listQuery).then((res) => {
          if (res.code === 200) {
            this.isloading = false;
            this.tableData = res.data.items;
            this.total = res.data.total;
            this.total = res.data.total;
            if (this.listQuery.page == 1) {
              // this.echartsFirstLoad = this.tableData;
              this.$nextTick(() => {
                this.toogleTbale(this.tableData);
              });
            }
            res.data.items.forEach((item: any) => {
              this.echartsXnama.push(item.organizename);
              this.echartsXdata.push(item.learnhour);
              this.echartsYdata.push(item.learntime);
            });
            drawEchart(
              this.$refs.echartstopDiv,
              this.echartsXnama,
              this.echartsXdata,
              "时长分布图",
              "学习时长",
              "组织名称"
            );
            drawEchart(
              this.$refs.echartsBotDiv,
              this.echartsXnama,
              this.echartsYdata,
              "次数分布图",
              "学习次数",
              "组织名称"
            );
          }
        });
      }
    } else {
      this.listQuery.begintime = null;
      this.listQuery.endtime = null;
      await getdatalist(this.listQuery).then((res) => {
        if (res.code === 200) {
          this.isloading = false;
          this.tableData = res.data.items;
        }
      });
    }
  }
  private async clearSearch() {
    (this.$refs.tableref as any).clearSelection();
    this.listQuery = {
      name: "",
      page: 1,
      limit: 10,
      begintime: null,
      endtime: null,
      timetype: "",
    };
    this.isactive = 4;
    this.getlist(this.listQuery);
  }
  // 时间控件改变事件

  private changeFocus() {
    if (this.listQuery.timetype == "") {
      this.$message({
        message: "请先选择时间粒度",
        type: "warning",
      });
    }
  }

  // 获取列表
  private async getlist(parm: any) {
    await getdatalist(parm).then((res) => {
      if (res.code === 200) {
        this.isloading = false;
        this.tableData = res.data.items;
        this.total = res.data.total;
        if (this.listQuery.page == 1) {
          this.$nextTick(() => {
            this.toogleTbale(this.tableData);
          });

          this.tableData.forEach((item: any) => {
            this.echartsXnama.push(item.organizename);
            this.echartsXdata.push(item.learnhour);
            this.echartsYdata.push(item.learntime);
          });
        }

        drawEchart(
          this.$refs.echartstopDiv,
          this.echartsXnama,
          this.echartsXdata,
          "时长分布图",
          "学习时长",
          "组织名称"
          // "时长"
        );
        drawEchart(
          this.$refs.echartsBotDiv,
          this.echartsXnama,
          this.echartsYdata,
          "次数分布图",
          "学习次数",
          "组织名称"
          // "次数"
        );
      }
    });
  }
  private toogleTbale(rows: any) {
    if (rows) {
      rows.forEach((row: any) => {
        (this.$refs.tableref as any).toggleRowSelection(row);
      });
    }
  }
  // 表格数据多选事件
  private async handleSelectionChange(val: any) {
    this.echartsXnama = [];
    this.echartsXdata = [];
    this.echartsYdata = [];
    this.echartsFirstUpdate = val;
    this.echartsFirstUpdate.forEach((item: any) => {
      this.echartsXnama.push(item.organizename);
      this.echartsXdata.push(item.learnhour);
      this.echartsYdata.push(item.learntime);
    });
    drawEchart(
      this.$refs.echartstopDiv,
      this.echartsXnama,
      this.echartsXdata,
      "时长分布图",
      "学习时长",
      "组织名称"
    );
    drawEchart(
      this.$refs.echartsBotDiv,
      this.echartsXnama,
      this.echartsYdata,
      "次数分布图",
      "学习次数",
      "组织名称"
    );
  }
  // 更改按钮状态
  private changetage(parm: any) {
    //将点击的元素的索引赋值给bian变量
    this.listQuery.begintime = null;
    this.listQuery.endtime = null;
    if (parm == 0) {
      this.listQuery.timetype = "week";
      this.allParams.beginType = "开始周";
      this.allParams.endType = "结束周";
      this.allParams.dateText = "yyyy 第 WW 周";
    } else if (parm == 1) {
      this.listQuery.timetype = "month";
      this.allParams.beginType = "开始月";
      this.allParams.endType = "结束月";
      this.allParams.dateText = "";
    } else if (parm == 2) {
      this.listQuery.timetype = "year";
      this.allParams.beginType = "开始年";
      this.allParams.dateText = "";
      this.allParams.endType = "结束年";
    }
    this.isactive = parm;
  }

  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }
  private handleClose() {
    this.allParams.dialogVisible = false;
  }

  private async handleSizeChange(val: number) {
    this.listQuery.limit = val;
    (this.$refs.tableref as any).clearSelection();
    this.getlist(this.listQuery);
  }
  private async handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.getlist(this.listQuery);
  }
}
